import { ICompanyProfileItem } from "../typings/companyProfile";

export const formatCompanyProfileData = (data: ICompanyProfileItem) => {
  return {
    address: data.address,
    city: data.city,
    zip: data.zip,
    state: data.state,
    company: data.company,
    contactEmail: data.contactEmail,
    contactPerson: data.contactPerson,
    fax: data.fax,
    checkAddress: data.checkAddress,
    checkCity: data.checkCity,
    checkState: data.checkState,
    checkZip: data.checkZip,
    checkCompany: data.checkCompany,
    phone: data.phone,
    remitType: data.remitType,
    checkDBA: data.checkDBA,
  };
};
